import { FC, InputHTMLAttributes } from "react";
import classNames from "classnames";
import { evoInputClassName } from "./evoFieldStyles";

type Props = InputHTMLAttributes<HTMLInputElement> & {
  className?: string;
};

export const EvoInput: FC<Props> = ({ className, ...rest }) => {
  return <input className={classNames(evoInputClassName, className)} {...rest} />;
};
